import { api } from '@/common/api';

const store = {
    namespaced: true,
    state() {
        return {
            measurers: [],
            statistic: [],
            unassigned: []
        };
    },

    mutations: {
        setDataFromResponse(state, data) {
            state.measurers = data.data.data.measurers || [];
            state.statistic = data.data.data.statistic || [];
            state.unassigned = data.data.data.unassigned || [];
        },
        deleteReservation(state, reservation) {
            const measurerReservation = state.measurers.find(measurer => measurer.id === reservation.employer_id).calendar[reservation.day].reservations[reservation.time];
            measurerReservation.id = null;
            measurerReservation.is_reserved = false;
            state.statistic[reservation.day][reservation.time].occupied -= 1;
        },
        createReservation(state, reservation) {
            const measurerReservation = state.measurers.find(measurer => measurer.id === reservation.employer_id).calendar[reservation.day].reservations[reservation.time];
            measurerReservation.id = reservation.id;
            measurerReservation.is_reserved = reservation.is_reserved;
            state.statistic[reservation.day][reservation.time].occupied += 1;
        },
        clearStore(state) {
            state.measurers = [];
            state.statistic = [];
            state.unassigned = [];
        }
    },
    actions: {
        async get({ state, commit }, params) {
            try {
                commit('setDataFromResponse', await api.get('/calendar/', { params }));
            } catch (e) {
                throw new Error(e);
            }
        },
        async createReservation({ state, commit }, params) {
            try {
                const response = await api.post('/calendar/reservation', params);
                commit('createReservation', response.data.data);
            } catch (e) {
                throw new Error(e);
            }
        },
        async deleteReservation({ state, commit }, params) {
            try {
                await api.delete(`/calendar/reservation/${params.reservation.id}`);
                commit('deleteReservation', params.reservation);
            } catch (e) {
                throw new Error(e);
            }
        }
    }
};

export default store;
